import { useLang } from '@/i18n';
import EfImg from '@elem/ui/ef-img';

export default function TheComp() {
    const { t } = useLang('theProduct.HighlightsA');
    return (
        <>
            <EfImg
                pc="https://websiteoss.ecoflow.com/upload/image/1724561089817/high_light_2.jpg"
                pad="https://websiteoss.ecoflow.com/upload/image/1724561089817/high_light_2.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1724569354025/high_light_2_h5.jpg"
            />
            <div className="card-box card-box-white card-box2 card-box-center">
                <div className="card-title">{t('item2_title')}</div>
                <div className="card-desc">{t('item2_desc')}</div>
            </div>
        </>
    );
}
